<!--
 * @Description: 订单管理
 * @Author: guqiang
 * @Date: 2021-10-18 10:05:34
 * @LastEditors: guqiang
 * @LastEditTime: 2021-11-02 13:21:00
-->

<template lang="pug">
    .page-order(v-if="this.getAuthority('OrderManage', 'OrderManageRead')",v-loading="loading",element-loading-text="玩命加载中")
        count-tabs(
            v-model="activeName"
            :options="tabOptions"
            @tab-click="getActive"
        )
        DataList(
            :props="props",
            :key="key"
            @search="onSearch",
            @reset="onReset",
            @beforeExport="beforeExport"
            @downloadComplete="downloadComplete"
        )
            .table-container
                el-table(:data="tableData")
                    el-table-column(align="center",prop="orderNo",label="订单号",width="180")
                    el-table-column(align="center",prop="statusDesc",label="订单状态",width="100")
                        template(slot-scope="scope")
                            //- svg-icon.status-desc(
                            //-     :icon-class="scope.row.status",
                            //-     :style="{width: scope.row.status === 'TO_BE_RECEIVED' ? '60px' : '71px' }"
                            //- )
                            <el-tag :type="scope.row.status | statusColor">{{ scope.row.statusDesc }}</el-tag>
                    el-table-column(align="center",prop="orderType",label="订单类型",width="100")
                    el-table-column(align="center",label="商品类型",width="100")
                        template(slot-scope="scope")
                            div {{ scope.row.orderItems[0].goodsType ? goodsTypeObj[scope.row.orderItems[0].goodsType] : '--' }}
                    el-table-column(align="center",label="商品信息",width="180")
                        el-tooltip(
                            slot-scope="scope"
                            effect="dark"
                            :content="scope.row.orderItems[0].spuName"
                            placement="top"
                            v-if="scope.row.orderItems[0].spuName"
                        )
                            div.limit2-row {{ scope.row.orderItems[0].spuName }}
                        .limit2-row(v-else) --
                    el-table-column(align="center",label="商品规格",width="180")
                        template(slot-scope="scope")
                            div {{ scope.row.orderItems[0].specInfo || '--' }}
                    el-table-column(align="center",label="下单人",width="180")
                        template(slot-scope="scope")
                            div(v-if="scope.row.userInfo") {{ scope.row.userInfo.phone || scope.row.userInfo.name ? `${scope.row.userInfo.name || ''} ${scope.row.userInfo.phone || ''}` :'--' }}
                            div(v-else) --
                    el-table-column(align="center",prop="salesPrice", label="订单总金额(元)",width="130")
                    el-table-column(align="center",prop="paymentPrice", label="应付款金额(元)",width="130")
                    el-table-column(align="center",label="数量",width="70")
                        template(slot-scope="scope")
                            div {{ scope.row.orderItems[0].quantity || '--' }}
                    el-table-column(align="center",prop="paymentTime",label="支付时间",width="160")
                        template(slot-scope="scope")
                            span {{ scope.row.paymentTime | dateFormat }}
                    el-table-column(align="center",prop="createTime",label="创建时间",width="160")
                        template(slot-scope="scope")
                            span {{ scope.row.createTime | dateFormat }}
                    el-table-column(align="center",prop="paymentWay",label="支付方式",width="120")
                    el-table-column(align="center",prop="shopInfo",label="门店信息",width="200")
                        template(slot-scope="scope")
                            span {{ scope.row.shopInfo && scope.row.shopInfo.shopName ? scope.row.shopInfo.shopName : '--' }}
                    el-table-column(align="center",prop="appType",label="订单来源",width="100")
                    el-table-column(align="center",prop="operation",label="操作",fixed='right',width="160")
                        template(slot-scope="scope")
                            el-button(
                                :disabled="!getAuthority('OrderManage', 'OrderManageDetail')",
                                @click="pageToOrder(scope.row)",
                                type="text",
                                size="small"
                            ) 查看
                            el-button(
                                v-if="scope.row.status === 'TO_BE_DELIVERED'"
                                :disabled="!getAuthority('OrderManage', 'OrderManageUpdate')",
                                @click="confirmDeliver(scope.row)",
                                type="text",
                                size="small"
                            ) 确认发货
                            el-button(
                                v-if="scope.row.status === 'IN_DISTRIBUTION' && userInfo.mode === 3"
                                :disabled="!getAuthority('OrderManage', 'OrderManageUpdate')",
                                @click="handleDistribution(scope.row)",
                                type="text",
                                size="small"
                            ) 配货完成
        //- 确认发货弹框
        confirm-deliver-dialog(
            v-if="confirmDeliverDialog.show"
            :dialogData="confirmDeliverDialog"
            @refresh="refreshList"
        )
        //- 配货完成
        CompleteDistribution(
            ref="completeDistribution"
            :showConfirm="showConfirm"
            :currentOrder="currentOrder"
            @refresh="refreshList"
            @cancel="() => showConfirm=false"
        )
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { orderApis } from '@/api';
import DataList from '@/components/DataList';
import CountTabs from '@/components/CountTabs.vue';
import CategoryCascader from '@/views/pointsGoods/components/CategoryCascader.vue';
import ConfirmDeliverDialog from './dialogs/ConfirmDeliver.vue';
import CompleteDistribution from './dialogs/CompleteDistribution.vue';
import { goodsTypeObj, orderStatus } from '@/enum/common';
import { pageRefresh } from '@/mixins';

export default {
    name: 'OrderManangeHome',
    components: {
        DataList,
        CategoryCascader,
        ConfirmDeliverDialog,
        CompleteDistribution,
        CountTabs,
    },
    data() {
        return {
            goodsTypeObj,
            key: 0,
            activeName: 'all',
            tabOptions: [
                {
                    label: '全 部',
                    name: 'all',
                    key: 'all',
                    count: 0,
                },
                {
                    label: '配货中',
                    name: 'IN_DISTRIBUTION',
                    key: 'inDistribution',
                    count: 0,
                },
                {
                    label: '待发货',
                    name: 'TO_BE_DELIVERED',
                    key: 'toBeDelivered',
                    count: 0,
                },
                {
                    label: '待收货',
                    name: 'TO_BE_RECEIVED',
                    key: 'toBeReceived',
                    count: 0,
                },
                {
                    label: '订单完成',
                    name: 'COMPLETED',
                    key: 'completed',
                    count: 0,
                },
            ],
            searchParams: {},
            loading: false,
            tableData: [],
            pageStruct: { pageSize: 10, pageNum: 1 },
            orderStatus,
            props: {
                total: 0,
                labelInset: true,
                exportUrl: '/mall/list/export',
                exportDisabled: false,
                options: [
                    {
                        type: 'date_range',
                        label: '创建时间',
                        field: 'Time',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                            startPlaceholder: '选择开始时间',
                            endPlaceholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'date_range',
                        label: '支付时间',
                        field: 'PaymentTime',
                        spanTimes: 1,
                        attrs: {
                            format: 'yyyy-MM-dd',
                            editable: false,
                            clearable: true,
                            startPlaceholder: '选择开始时间',
                            endPlaceholder: '选择结束时间',
                        },
                    },
                    {
                        type: 'select',
                        label: '支付方式',
                        field: 'paymentWay',
                        default: null,
                        options: [
                            {
                                label: '微信',
                                value: 'WXPAY',
                            },
                            {
                                label: '积分抵扣',
                                value: 'POINTS_DEDUCTION',
                            },
                            {
                                label: '支付宝',
                                value: 'ALIPAY',
                            },
                        ],
                    },
                    {
                        type: 'component',
                        label: '商品类目',
                        component: CategoryCascader,
                        field: 'goodsCategory',
                        default: null,
                        options: {
                            attrs: {
                                placeholder: '请选择',
                                popperClass: 'cascader-filter',
                            },
                        },
                    },
                    {
                        type: 'select',
                        label: '订单状态',
                        field: 'status',
                        default: null,
                        options: orderStatus,
                        attrs: {
                            clearable: true,
                            disabled: false,
                        },
                    },
                    {
                        type: 'input',
                        label: '商品信息',
                        field: 'queryKey',
                        attrs: {
                            placeholder: '商品名称、商品编号、SKU编号',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'input',
                        label: '订单号',
                        field: 'orderNo',
                        attrs: {
                            placeholder: '请输入',
                            clearable: true,
                            maxlength: 50,
                        },
                    },
                    {
                        type: 'select',
                        label: '订单类型',
                        field: 'orderType',
                        default: null,
                        options: [
                            {
                                label: '积分商品订单',
                                value: 'POINT',
                            },
                            {
                                label: '普通订单',
                                value: 'NORMAL',
                            },
                            {
                                label: '线下订单',
                                value: 'OFFLINE',
                            },
                        ],
                    },
                    {
                        type: 'select',
                        label: '商品类型',
                        field: 'goodsType',
                        default: null,
                        options: [
                            {
                                label: '实物商品',
                                value: 'PHYSICAL_GOODS',
                            },
                            {
                                label: '电子券',
                                value: 'ELECTRONIC_COUPON',
                            },
                            {
                                label: '服务套餐',
                                value: 'SERVICE_PACK',
                            },
                        ],
                    },
                    {
                        type: 'select',
                        label: '订单来源',
                        field: 'appType',
                        default: null,
                        options: [
                            {
                                label: '微信小程序',
                                value: 'MA',
                            },
                            {
                                label: '凯励程APP',
                                value: 'APP',
                            },
                            {
                                label: 'CRM门店销售',
                                value: 'SAAS_SHOP',
                            },
                        ],
                    },
                ],
            },
            currentOrder: null,
            showConfirm: false,
            confirmDeliverDialog: {
                title: '确认发货',
                show: false,
                orderData: {},
            },
        };
    },
    mixins: [
        pageRefresh(
            [
                'OrderManageDetail',
            ],
            'refreshList',
        ),
    ],
    filters: {
        statusColor(val) {
            const statusItem = orderStatus.filter(v => v.value === val);
            return statusItem.length ? statusItem[0].color : null;
        },
    },
    computed: {
        ...mapGetters('user', ['getAuthority']),
        ...mapState('user', [
            'userInfo',
            'orgList',
        ]),
    },
    created() {
        this.props.exportDisabled = !this.getAuthority('OrderManage', 'OrderManageExport');
        if (this.userInfo.mode === 2 || this.userInfo.mode === 3) {
            const options = this.orgList;
            const multipleProps = {
                type: 'select',
                label: '选择门店',
                field: 'shopId',
                options,
                attrs: {
                    clearable: true,
                    filterable: true,
                    'collapse-tags': true,
                    placeholder: '请选择门店',
                },
            };
            this.props.options.push(multipleProps);
        }
        this.getListCount();
    },
    watch: {
        activeName: {
            immediate: true,
            handler(name) {
                this.props.options.forEach((v) => {
                    if (v.field === 'status') {
                        v.attrs.disabled = name !== 'all';
                        v.default = name !== 'all' ? name : '';
                    }
                });
            },
        },
    },
    methods: {
        getActive(tab) {
            this.searchParams = {
                ...this.searchParams,
                status: tab.name === 'all' ? '' : tab.name,
            };
            this.key = this.key + 1;
        },
        // 获取tab统计
        async getListCount() {
            try {
                const { code, data } = await orderApis.getListCount();
                if (code === 0 && data) {
                    this.tabOptions = this.tabOptions.map(v => ({
                        ...v,
                        count: data[v.key] || 0,
                    }));
                }
            } catch (err) {
                this.tabOptions = this.tabOptions.map(v => ({
                    ...v,
                    count: 0,
                }));
            }
        },
        // 跳转到商品添加页面
        pageToOrder(rowData) {
            const { navType } = this.$route.query;
            const { id } = rowData;
            this.$router.push({ name: 'OrderManageDetail', query: { navType, id } });
        },
        // 条件查询商品列表
        onSearch(filters) {
            for (const key in filters) {
                if (key && !filters[key]) {
                    delete filters[key];
                }
            }
            this.searchParams = {
                ...filters,
                createTimeStart: filters.beginTime,
                createTimeEnd: filters.endTime,
                paymentTimeStart: filters.beginPaymentTime,
                paymentTimeEnd: filters.endPaymentTime,
                beginTime: null,
                endTime: null,
                beginPaymentTime: null,
                endPaymentTime: null,
            };
            const params = {
                pageNum: filters.pageNum,
                pageSize: filters.pageSize,
                ...this.searchParams,

            };
            this.getTableData(params);
        },
        // 获取客户积分概况列表
        getTableData(params) {
            if (!this.getAuthority('OrderManage', 'OrderManageRead')) return;
            this.props.exportParams = this.searchParams;
            this.loading = true;
            orderApis.getOrders(params)
                // eslint-disable-next-line no-unused-vars
                .then(({ data }) => {
                    this.tableData = data.list;
                    this.props.total = data.total;
                })
                .catch(() => {
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 刷新列表
        refreshList() {
            this.getTableData(this.searchParams);
            this.showConfirm = false;
            this.getListCount();
        },
        // 配货完成
        async handleDistribution(row) {
            this.currentOrder = row;
            this.showConfirm = true;
            this.$refs.completeDistribution.$refs.confirmDialog.dialogVisible = true;
        },
        // 确认发货
        confirmDeliver(row) {
            this.confirmDeliverDialog.orderData = row || {};
            this.confirmDeliverDialog.show = true;
        },
        // 点击导出
        beforeExport() {
            this.loading = true;
        },
        // 导出完成
        downloadComplete() {
            this.loading = false;
        },
        // 重置时清空级联数据
        onReset() {
            this.key = this.key + 1;
        },
    },
};
</script>
<style lang="scss">
.page-order {
    .el-table {
        .el-tag{
            height: 22px;
            padding: 0 8px;
            line-height: 20px;
            border-radius: 2px;
            &.el-tag--warning {
                background: #FFFBE6;
                border: 1px solid #FFE58F;
                color: #FAAD14;
            }
            &.el-tag--primary {
                background: #F0F7FF;
                border: 1px solid #A3CBFF;
                color: #2970FF;
            }
            &.el-tag--info {
                background: #FFFFFF rgba(0,0,0,0.04);
                border: 1px solid rgba(0,0,0,0.15);
                color: rgba(0,0,0,0.65);
            }
            &.el-tag--success  {
                background: #F6FFED;
                border: 1px solid #B7EB8F;
                color: #52C41A;
            }
        }
    }
}
</style>
<style scoped lang="scss">
    .page-order {
        background: #ffffff;
       .page-order__header {
            height: 50px;
            margin-bottom: 1px;
            display: flex;
            align-items: center;
            padding: 0 20px;
            border-bottom: 1px solid #EEF2F8;
            .title {
                flex: 1;
                height: 50px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
                line-height: 50px;
            }
            .button {
                height: 32px;
            }
            .button + .button {
                margin-left: 20px;
            }

        }
        .form-container {
            border-top: 1px solid rgba(0,0,0,0.06);
            padding-top: 20px;
            margin-top: 20px;
            .el-form .el-form-item {
                margin-bottom: 0;
            }
        }
    }
    .status-desc{
        height: 25px;
        width: 60px;
    }
    .limit2-row {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: normal;
    }
</style>

<style lang="scss">
.table-container{
    .el-table td, .el-table th {
        padding: 0;
        height: 50px !important;
    }
    .el-table td, .el-table td {
        padding: 0;
        height: 68px !important;
    }
    .el-table th .cell{
        padding: 0px 20px;
    }
    .el-table td .cell{
        padding: 0px 20px;
    }
}

</style>
